import {
    InteractiveQuestion,
    QuestionsCollection,
} from '../../api/models/survey';
import {
    getBuiltSurvey,
    isCustomSurveyQuestion,
    SELECTED_QUESTION_GROUP_BUYER,
    shouldIncludeInBuyerQuestions,
    shouldIncludeInPaymentQuestions,
    SurveyQuestion,
} from '../../models/survey';
import { WithOrderNamespace } from '../../state/order';
import { WithSurveyNamespace } from '../../state/survey';
import { isRequiredQuestion } from '../../utils/surveys';
import { createSelector, getNamespaceValue } from '../utils/selector';
import {
    getInteractiveQuestionsByAttendeeId,
    getQuestionsCollection,
} from './pureSelectors';

export const getQuestionsForBuyer = createSelector<
    Array<SurveyQuestion>,
    (
        questions: QuestionsCollection,
        interactiveQuestionsByAttendeeId: Record<
            string,
            Array<InteractiveQuestion>
        >,
        taxName?: string,
    ) => Array<SurveyQuestion>
>(
    (state: WithSurveyNamespace) => getQuestionsCollection(state),
    (state: WithSurveyNamespace) => getInteractiveQuestionsByAttendeeId(state),
    (state: WithOrderNamespace) => getNamespaceValue(state.order, 'taxIdName'),
    (questions, interactiveQuestionsByAttendeeId, taxIdName) =>
        getBuiltSurvey(
            questions,
            interactiveQuestionsByAttendeeId[SELECTED_QUESTION_GROUP_BUYER] ??
                [],
            shouldIncludeInBuyerQuestions,
            taxIdName,
        ),
);

export const getPaymentQuestionsAndRequiredCustomQuestionsForBuyer =
    createSelector<
        Array<SurveyQuestion>,
        (
            questionsCollection: QuestionsCollection,
            interactiveQuestionsByAttendeeId: Record<
                string,
                Array<InteractiveQuestion>
            >,
            taxName?: string,
        ) => Array<SurveyQuestion>
    >(
        (state: WithSurveyNamespace) => getQuestionsCollection(state),
        (state: WithSurveyNamespace) =>
            getInteractiveQuestionsByAttendeeId(state),
        (state: WithOrderNamespace) =>
            getNamespaceValue(state.order, 'taxIdName'),
        (questions, interactiveQuestionsByAttendeeId, taxIdName) =>
            getBuiltSurvey(
                questions,
                interactiveQuestionsByAttendeeId[
                    SELECTED_QUESTION_GROUP_BUYER
                ] ?? [],
                (questionId) =>
                    (isCustomSurveyQuestion(questionId) &&
                        shouldIncludeInBuyerQuestions(questionId)) ||
                    shouldIncludeInPaymentQuestions(questionId),
                taxIdName,
            ).filter(
                (question, _index, questions) =>
                    isRequiredQuestion(question, questions) ||
                    shouldIncludeInPaymentQuestions(question.name),
            ),
    );
